(() => {
  'use strict';

  const VERSION = '6.0.3.1';
  const MAX_DESIGN_BYTES = 45000;

  const init = (root) => {
    if (!root || root.dataset.ufStabilized6031 === 'true') return;
    const designer = root.querySelector('[data-uf-designer]');
    const form = root.closest('form');
    if (!designer || !form) return;
    root.dataset.ufStabilized6031 = 'true';
    root.dataset.ufVersion = VERSION;

    let submitting = false;
    let submitTimer = 0;

    const announce = (message, type = 'info') => {
      let region = root.querySelector('[data-uf-stability-status]');
      if (!region) {
        region = document.createElement('div');
        region.dataset.ufStabilityStatus = '';
        region.className = 'uf-stability-status';
        region.setAttribute('role', 'status');
        region.setAttribute('aria-live', 'polite');
        designer.appendChild(region);
      }
      region.dataset.type = type;
      region.textContent = message;
      window.clearTimeout(region._ufTimer);
      region._ufTimer = window.setTimeout(() => { region.textContent = ''; }, 4500);
    };

    const validatePayload = () => {
      const field = form.querySelector('[name="properties[_UNIQ Design Data]"]');
      if (!field || !field.value) return true;
      try {
        JSON.parse(field.value);
      } catch (_error) {
        announce('The design data could not be prepared. Please make one small change and try again.', 'error');
        return false;
      }
      const bytes = new Blob([field.value]).size;
      if (bytes > MAX_DESIGN_BYTES) {
        announce('This design is too complex to add to cart. Remove duplicated layers or simplify the artwork.', 'error');
        return false;
      }
      return true;
    };

    form.addEventListener('submit', (event) => {
      if (submitting) {
        event.preventDefault();
        return;
      }
      if (!validatePayload()) {
        event.preventDefault();
        return;
      }
      submitting = true;
      root.classList.add('is-uf-submitting');
      const button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('aria-disabled', 'true');
      submitTimer = window.setTimeout(() => {
        submitting = false;
        root.classList.remove('is-uf-submitting');
        if (button) button.removeAttribute('aria-disabled');
      }, 5000);
    }, true);

    designer.querySelectorAll('input[type="file"]').forEach((input) => {
      input.addEventListener('change', () => {
        const file = input.files?.[0];
        if (!file) return;
        if (file.size > 8 * 1024 * 1024) {
          input.value = '';
          announce('Artwork must be smaller than 8 MB.', 'error');
          return;
        }
        announce(`${file.name} is ready for preview.`, 'success');
      });
    });

    const svg = designer.querySelector('[data-uf-canvas-svg]');
    if (svg) {
      svg.setAttribute('focusable', 'true');
      svg.setAttribute('aria-label', 'Interactive engraving design canvas');
      svg.addEventListener('pointerdown', () => svg.focus({ preventScroll: true }));
    }

    window.addEventListener('pageshow', (event) => {
      if (!event.persisted || !root.isConnected) return;
      root.classList.remove('is-uf-submitting');
      submitting = false;
      form.querySelector('[type="submit"]')?.removeAttribute('aria-disabled');
      designer.dispatchEvent(new CustomEvent('uf:canvas-updated'));
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(root)) return;
      window.clearTimeout(submitTimer);
    }, { once: true });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-uf-personalization-side]').forEach((root) => {
      try { init(root); } catch (error) { console.error('[UNIQ Design Studio 6.0.3.1]', error); }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
